import type { ValueOf } from '../util/typeUtils';

export const CHAT_COMMANDS = {
    linkChat: 'linkChat',
    // System-only — ensurePartnerLinked retry fallback; not granted to human roles.
    linkPartnerChat: 'linkPartnerChat',
    markChatResolved: 'markChatResolved',
    markChatUnresolved: 'markChatUnresolved',
    // System-only — cursor saga + Failed retry; not granted to human roles.
    requestInboundReadReceipt: 'requestInboundReadReceipt',
    sendMessage: 'sendMessage',
    sendTemplateMessage: 'sendTemplateMessage',
    startChat: 'startChat',
    startPartnerChat: 'startPartnerChat',
    unlinkChat: 'unlinkChat',
} as const;

export type CHAT_COMMAND = ValueOf<typeof CHAT_COMMANDS>;
